export const nameServicesKey = 'nameServices';
export const typeServicesKey = 'typeServices';
export const clearServicesKey = 'clearServices';
